import { registerDict, type Lang } from '../lib/i18n';

/** Every file in dict/ exports { en, uk } (Russian is the key itself). New files are picked up without edits here. */
const files = import.meta.glob<{ default?: { en?: Record<string, string>; uk?: Record<string, string> } } & Record<string, unknown>>('./dict/*.ts', { eager: true });
for (const mod of Object.values(files)) {
  const d = (mod.default ?? mod) as { en?: Record<string, string>; uk?: Record<string, string> };
  if (d.en) registerDict('en' as Lang, d.en);
  if (d.uk) registerDict('uk' as Lang, d.uk);
}
